import { Controller } from "@hotwired/stimulus";
import startIntlPhone from "../utils/intl_phone";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.initializeIntlInput();
  }

  initializeIntlInput() {
    this.inputTargets.forEach((input) => {
      startIntlPhone(input, { initialCountry: "us" });
    });
  }
}
